import styled from 'styled-components';

export const Wrapper = styled.span<{ $gap: number }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme, $gap }) => theme.spacing($gap)}px;
`;

export const IconWrapper = styled.span`
  flex: 0 0 auto;
`;
